import React from "react";
import Control from '../store/control';
import MarkingTest from './markingTest';
import MarkingFinal from './markingFinal';

const ObjectAk = () => {
  const type     = Control.Get("type");
  const isTest   = (type == 'TestSocket'); 
  const isFinal  = (type == 'FinalDevice'); 

  return (
    <>
      { isTest  ? <MarkingTest/> : null }
      { isFinal ? <MarkingTest/> : null }
    </>
  );
  
};

export default ObjectAk;